export const partitionFileIntoChunks = async (
  file: File,
  chunkSize: number
): Promise<ArrayBuffer[]> => {
  const fileBuffer = await file.arrayBuffer();
  const totalChunks = Math.ceil(file.size / chunkSize);
  const fileChunks: ArrayBuffer[] = [];
  for (let i = 0; i < totalChunks; i++) {
    fileChunks.push(fileBuffer.slice(i * chunkSize, i * chunkSize + chunkSize));
  }
  return fileChunks;
};
